import { render, staticRenderFns } from "./investors-panel.vue?vue&type=template&id=93e1057a&scoped=true&"
import script from "./investors-panel.vue?vue&type=script&lang=ts&"
export * from "./investors-panel.vue?vue&type=script&lang=ts&"
import style0 from "./investors-panel.vue?vue&type=style&index=0&id=93e1057a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93e1057a",
  null
  
)

export default component.exports